import { render, staticRenderFns } from "./PoultryHouseVisit.vue?vue&type=template&id=0bb8942c&scoped=true&"
import script from "./PoultryHouseVisit.vue?vue&type=script&lang=js&"
export * from "./PoultryHouseVisit.vue?vue&type=script&lang=js&"
import style0 from "./PoultryHouseVisit.vue?vue&type=style&index=0&id=0bb8942c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb8942c",
  null
  
)

export default component.exports